var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Статусы объекта",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      "route-create": "LocationStatusAdd",
      "route-edit": "LocationStatusEdit",
      "route-view": "LocationStatusView",
      "route-path": "/location_statuses",
      "can-edit": _vm.canEditLocationStatusCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-435b3aac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435b3aac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/LocationStatuses/LocationStatuses.vue
// module id = null
// module chunks = 